import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const roleCards = [
{
  to: '/vagas?setor=churrasqueiro',
  image: 'https://static.lumi.new/aa/aa128855bd442b960ff35ba36b1f84db.png',
  title: 'Churrasqueiro',
  desc: 'Especialista nos cortes e preparo da carne',
  rotate: 'rotate-3 translate-y-4'
},
{
  to: '/vagas?setor=barman',
  image: 'https://static.lumi.new/49/49f9625749d5fce6974dc77673634c84.png',
  title: 'Barman',
  desc: 'Mixologistas profissionais',
  rotate: '-rotate-2 -translate-y-3'
},
{
  to: '/vagas?setor=garcom',
  image: 'https://static.lumi.new/9a/9a664cc9ce6cb761e21d711329190054.png',
  title: 'Garcom',
  desc: 'Atendimento de excelencia',
  rotate: 'rotate-2 translate-y-6'
},
{
  to: '/vagas?setor=cozinheiro',
  image: 'https://static.lumi.new/2e/2e0d7ad489500fd53bc65b83f3a030e4.png',
  title: 'Cozinheiro',
  desc: 'Culinaria de alto nivel',
  rotate: '-rotate-3 -translate-y-2'
},
{
  to: '/vagas?setor=limpeza',
  image: 'https://static.lumi.new/72/7255a64f31fb72dd03987783f85a568c.png',
  title: 'Limpeza',
  desc: 'Higiene e organizacao impecavel',
  rotate: 'rotate-4 translate-y-5'
},
{
  to: '/vagas?setor=sommelier',
  image: 'https://static.lumi.new/42/42b71525fcc977c81e7b962c415cd04a.png',
  title: 'Sommelier',
  desc: 'Especialista em vinhos e harmonizacao',
  rotate: '-rotate-2 -translate-y-4'
},
{
  to: '/vagas?setor=bailarino',
  image: 'https://static.lumi.new/a1/a102b937fae93c82593e4a55bcc3da7b.png',
  title: 'Espetaculo Brasileiro',
  desc: 'Bailarinos profissionais',
  rotate: 'rotate-3 translate-y-3'
},
{
  to: '/vagas?setor=passador',
  image: 'https://static.lumi.new/68/6801f2e1471a4673ec42800d74a08aa0.png',
  title: 'Passador de Carne',
  desc: 'Servico de rodizio especializado',
  rotate: '-rotate-3 translate-y-2'
},
{
  to: '/vagas?setor=ajudante',
  image: 'https://static.lumi.new/69/6917ec3a16238212538ac4b0c4084c0f.png',
  title: 'Ajudante de Cozinheiro',
  desc: 'Suporte e preparo de alimentos',
  rotate: 'rotate-2 -translate-y-3'
},
{
  to: '/vagas?setor=musico',
  image: 'https://static.lumi.new/72/7284f04e48b3ed54bedcc69d4863e490.png',
  title: 'Musicos',
  desc: 'Musica ao vivo para encantar os clientes',
  rotate: '-rotate-2 translate-y-4'
},
{
  to: '/vagas?setor=recepcionista',
  image: 'https://static.lumi.new/70/7086a5e28d35283863f9d9d3e38d46a4.png',
  title: 'Recepcionistas',
  desc: 'Primeiro contato e atendimento ao cliente',
  rotate: 'rotate-2 translate-y-3'
}];


function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-black via-[#1a1a1a] to-[#2a0a0a] text-white py-20 lg:py-28 overflow-hidden">
      {/* Decorative Elements - Fire/Smoke Effect */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#E53935] rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#C62828] rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 w-80 h-80 bg-[#D32F2F] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center text-left">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in pb-[438px]">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-left">
              BBQ Jobs &mdash; <span className="bg-gradient-to-r from-[#E53935] via-[#FF5722] to-[#D32F2F] bg-clip-text text-transparent">A comunidade mundial dos profissionais da gastronomia brasileira.</span>
            </h1>
            <p className="text-xl text-gray-200 leading-relaxed">
              Crie seu curriculo, encontre oportunidades e conecte-se com restaurantes e profissionais ao redor do mundo.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/cadastro?redirect=curriculo" className="bg-gradient-to-r from-[#C62828] to-[#E53935] text-white px-8 py-4 rounded-lg font-bold text-lg hover:shadow-2xl hover:shadow-[#E53935]/50 hover:scale-105 transition-all flex items-center justify-center gap-2 border-2 border-[#8D0000] no-underline">
                Criar perfil profissional
                <ArrowRight size={20} />
              </Link>
              <Link to="/cadastro" className="bg-[#5D4037] backdrop-blur-sm text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#6D4C41] transition-all border-2 border-[#8D6E63] no-underline flex items-center justify-center gap-2">
                Cadastrar estabelecimento
                <ArrowRight size={20} />
              </Link>
            </div>

            {/* Fase de testes */}
            <div className="pt-8 border-t border-[#5D4037]">
              <div className="inline-flex items-center gap-2 bg-[#3E2723]/70 border border-[#8D6E63] rounded-full px-4 py-1.5 text-sm font-semibold text-[#FFCCBC]">
                <span className="w-2 h-2 rounded-full bg-[#E53935]"></span>
                Fase de testes
              </div>
              <p className="text-gray-200 mt-4 text-lg leading-relaxed">
                Estamos em fase de testes. Seja um dos primeiros profissionais ou estabelecimentos da comunidade BBQ Jobs.
              </p>
              <p className="text-gray-400 mt-2 text-base leading-relaxed">
                Crie seu perfil e participe da primeira fase de testes da comunidade BBQ Jobs.
              </p>
            </div>
          </div>

          {/* Right Visual - Professional Collage (Scattered Layout) */}
          <div className="hero-role-grid relative grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 lg:gap-5 py-4 self-start -mt-4 items-stretch auto-rows-fr max-sm:[&>a]:!rotate-0 max-sm:[&>a]:!translate-y-0 max-sm:[&>a]:!translate-x-0 max-sm:[&>a]:h-full">
            {roleCards.map((card) =>
            <Link
              key={card.to}
              to={card.to}
              className={`hero-role-card group bg-[#3E2723]/60 backdrop-blur-md rounded-3xl overflow-hidden hover:scale-110 transition-all duration-300 hover:shadow-2xl hover:shadow-[#E53935]/30 border-2 border-[#8D6E63] hover:border-[#E53935] flex flex-col items-center text-center ${card.rotate} hover:rotate-0 no-underline text-white cursor-pointer`}>

                {/* Imagem do profissional */}
                <div className="w-full h-36 sm:h-40 overflow-hidden relative">
                  <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#3E2723] via-transparent to-transparent opacity-80"></div>
                </div>
                {/* Texto */}
                <div className="px-4 pb-5 pt-3 -mt-2 relative z-10">
                  <h3 className="font-bold text-base sm:text-lg mb-1">{card.title}</h3>
                  <p className="text-xs sm:text-sm text-gray-300 leading-snug">{card.desc}</p>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>);

}

export default Hero;